// Service público de setores — usa GET /api/sectors/ (apps/users/admin_sector_views.py
// PublicSectorListView, registrado em config/urls.py:83). Retorna setores ativos
// para dropdowns de cadastro/compartilhamento. Requer autenticação.

import apiService from './api.service';
import { PublicSector } from '@/types/agents';

type Paginated<T> = T[] | { results: T[] };

function unwrap<T>(data: Paginated<T>): T[] {
  return Array.isArray(data) ? data : data.results ?? [];
}

class SectorsService {
  async list(): Promise<PublicSector[]> {
    const response = await apiService.get<Paginated<PublicSector>>('/sectors/');
    return unwrap(response.data);
  }
}

export default new SectorsService();
